import React, { FC, useState } from 'react';
import './RequestAdditionalFiles.scss';

import { ReactComponent as TrashIcon } from 'assets/images/icons/trash.svg';
import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { hideModal } from 'redux/actions';
import { apiSlice } from 'redux/api/api-slice';
import { useRequestAdditionalFilesMutation } from 'redux/api/staff/expert/expert-applications-api';
import {
  selectCurrentQuestionnaire,
  selectCurrentApplication,
} from 'redux/selectors/staff/applications';

const RequestAdditionalFiles: FC = () => {
  const dispatch = useAppDispatch();
  const modalData = useAppSelector(state => state.modal.data);
  const closeModal = () => dispatch(hideModal());

  const application = useAppSelector(selectCurrentApplication);
  const questionnaire = useAppSelector(selectCurrentQuestionnaire);

  const [requestAdditionalFiles] = useRequestAdditionalFilesMutation();
  const [document, setDocument] = useState<string[]>(['']);
  const [errorMessages, setErrorMessages] = useState<string[]>(['']);

  const validateFields = (): boolean => {
    const newErrors = document.map(doc =>
      doc.trim() ? '' : 'Обязательно к заполнению'
    );
    setErrorMessages(newErrors);
    return !newErrors.every(err => err !== '');
  };

  const addField = () => {
    setDocument([...document, '']);
  };

  const deleteField = (index: number) => {
    if (document.length > 1) {
      setDocument(document.filter((_, i) => i !== index));
    }
  };

  const handleDocumentChange = (index: number, value: string) => {
    const newDocument = [...document];
    newDocument[index] = value;
    setDocument(newDocument);
  };

  const handleSave = async () => {
    const isValid = validateFields();
    if (!isValid || !application) return;

    const currentComment = (modalData.currentComment || '').trim();
    console.log(currentComment);

    const newDocumentsText = `Экспертом запрошены дополнительные документы:\n${document
      .filter(doc => doc.trim())
      .map((doc, index) => `${index + 1}. ${doc}`)
      .join('\n')}`;

    const fullComment = currentComment
      ? `${currentComment}\n\n${newDocumentsText}`
      : newDocumentsText;

    try {
      await requestAdditionalFiles({
        applicationId: application.id,
        comment: fullComment,
      }).unwrap();
      dispatch(apiSlice.util.invalidateTags(['ApplicationByStaff']));
      modalData.setCommentValue?.(fullComment);
      closeModal();
    } catch (error) {
      console.error('error:', error);
    }
  };

  if (!application || !questionnaire) {
    return (
      <TemplateModal title="Запросить дополнительные документы">
        <div>Загрузка...</div>
      </TemplateModal>
    );
  }

  return (
    <TemplateModal title="Запросить дополнительные документы">
      <div className="request-files-modal">
        <div className="required-file-group">
          {document.map((doc, index) => (
            <div key={index} className="document-field">
              <label>Запрашиваемый документ {index + 1}:</label>
              <div className="input-btn">
                <InputV2
                  type="string"
                  style={{ width: '100%' }}
                  maxLength={50}
                  value={doc}
                  error={errorMessages[index] || undefined}
                  onChange={e => handleDocumentChange(index, e.target.value)}
                />
                <Button
                  type="button"
                  className="statements-container__element-btn-panel_icon"
                  onClick={() => deleteField(index)}
                >
                  <TrashIcon />
                </Button>
              </div>
            </div>
          ))}
          <Button onClick={addField}>Добавить документ</Button>
        </div>
        <div className="action">
          <Button theme="success" onClick={handleSave}>
            Сохранить
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default RequestAdditionalFiles;
